export enum NodeType {
    Start,
    Sequence,
    End    
}